import { call, takeEvery, select } from 'redux-saga/effects';
import {
  TRACK_AUDIO_OPEN,
  TRACK_CURSOR_SETTINGS_OPEN,
  TRACK_TOGGLE_GRID,
  TRACK_OPEN_DOWNLOAD
} from 'JS/actionCreators/trackingActions';
import { getScribeById } from 'JS/sagas/selectors';

import { track } from '../mixpanelProvider';

function* trackAudioOpen({ scribeId }) {
  yield call(track, 'Open Scribe Audio', { 'Scribe ID': scribeId });
}

function* trackCursorSettingsOpen({ scribeId }) {
  yield call(track, 'Open Drawing Hand', { 'Scribe ID': scribeId });
}

function* trackToggleGrid({ scribeId, gridlinesOn, eventTrigger }) {
  yield call(track, gridlinesOn ? 'Turn Gridlines On' : 'Turn Gridlines Off', {
    'Scribe ID': scribeId,
    'Event Trigger': eventTrigger
  });
}

function* trackOpenDownload({ scribeId }) {
  const scribe = yield select(state => getScribeById(state, scribeId));
  yield call(track, 'Click Download Button', {
    'Scribe ID': scribeId,
    'Scribe Type': scribe.source?.type || 'unknown'
  });
}

export default function* trackUiSagas() {
  yield takeEvery(TRACK_AUDIO_OPEN, trackAudioOpen);
  yield takeEvery(TRACK_CURSOR_SETTINGS_OPEN, trackCursorSettingsOpen);
  yield takeEvery(TRACK_TOGGLE_GRID, trackToggleGrid);
  yield takeEvery(TRACK_OPEN_DOWNLOAD, trackOpenDownload);
}
